module.exports = __webpack_public_path__ + "files/SPIADI2026 - Annexe Micro-organismes.29b05f3813344917da037a0e3dcfb142.pdf";